import {
    ModelCatalogueService,
    modelCatalogueServiceDefinition
} from '@volkswagen-onehub/cms-user-interactions';
import {ServiceRegistration} from './ServiceRegistration';

export function createModelCatalogueService(): ServiceRegistration<ModelCatalogueService> {
    return {
        definition: modelCatalogueServiceDefinition
    };
}
